<template>
<v-layout row class="dense-row">
  <v-flex xs2 md2 pt2>
    <div class="text-xs-center">
      {{label}}
      </div>
  </v-flex>
  <v-flex xs3 md3 offset-xs2>
    <v-btn-toggle>
      <v-btn @click="decrement">
        &nbsp;&nbsp;-&nbsp;&nbsp;
      </v-btn>
      <v-btn @click="increment">
        &nbsp;&nbsp;+&nbsp;&nbsp;
      </v-btn>
    </v-btn-toggle>
  </v-flex>
  <v-spacer></v-spacer>
  <v-flex xs3 md3>
    <v-text-field solo small v-model="quantity" :value="value"></v-text-field>
  </v-flex>
</v-layout>
</template>

<script>
export default {
  props: ['value', 'label'],
  data() {
    return {
      quantity: this.value,
    };
  },
  watch: {
    quantity(newVal, oldVal) {
      this.$emit('input', this.quantity);
    },
  },
  methods: {

    increment() {
      this.quantity++;
    },
    decrement() {
      if (this.quantity > 0) {
        this.quantity--;
      }
    },
    set(value) {
      this.quantity = value;
    },
  },
};
</script>

<style>
.dense-row .v-input__control {
  min-height: 37px !important;
}
</style>
